// UI imports
import PrivatePageLayout from '../../../layout/privatePageLayout/PrivatePageLayout';
import Taskboard from '../../../components/stateful/taskBoard/Taskboard';
// import { getAllTaskBoardColumns } from '../../../features/state/StateTaskBoardColumn-slice';
import { Loader } from '@progress/kendo-react-indicators';
import './WorkQueue.scss'
import { useWorkQueueController } from './WorkQueueController';

function WorkQueue(props: any) {
  const { taskBoardColumns, filings, loading } = useWorkQueueController(props);

  const renderWorkQueue = () => {
    return (
      <div className="work-queue">
        {
          !loading && filings && taskBoardColumns.length > 0 ? (
            <Taskboard columns={taskBoardColumns} filings={filings} />
          ) : (
            <Loader type="converging-spinner" />
          )
        }
      </div>
    );
  }

  return (
    <PrivatePageLayout>
      {renderWorkQueue()}
    </PrivatePageLayout>
  )
}

export default WorkQueue